module.exports = __webpack_public_path__ + "img/cloud-bg2.587f55c9.png";